import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { phuHuynhApi } from '../../../api/phuHuynhApi';
import styles from "./CSKHDangKyHistory.module.css"
import { useSelector } from 'react-redux';
const CSKHDangKyHistory = ({ ts_phuhuynh_id }) => {
    const [dataSource, setDataSource] = useState([]);
    const { dm_coso_id } = useSelector((x) => x.coSo);
    useEffect(() => {
        handleReload();
    }, [ts_phuhuynh_id])
    const handleReload = async () => {
        const res = await phuHuynhApi.SelectLichSuDangKy(ts_phuhuynh_id, dm_coso_id);
        if (res.is_success) {
            setDataSource(res.data)
        }
    }
    return (
        <div className={styles.container}>
            {dataSource.length == 0 &&
                <p>Không có dữ liệu đăng ký</p>
            }
            {dataSource.map((x) => {
                return (
                    <div className={styles.item} key={x.id}>
                        <p>Chiến dịch: <b>{x.ten_chien_dich}</b>, ngày đăng ký <b>{moment(x.register_date).format("DD/MM/YYYY")}</b></p>
                        <p>Học sinh: <b>{x.ho_ten_hoc_sinh}</b>, Khối <b>{x.khoi_lop}</b> </p>
                        <p>Ghi chú: <b>{x.ghi_chu}</b></p>
                    </div>
                );
            })}
        </div>
    );
};

export default CSKHDangKyHistory;